import { useFetchInspectionProgressQuery } from 'app/features/inspection/api';

// const { apiGetInspectionProgress } = require('../api');

const useFetchInspectionProgress = (inspectionId: string) => {
  const queryState = useFetchInspectionProgressQuery(inspectionId);
  return { ...queryState };
};

export default useFetchInspectionProgress;
